import { useAppSelector } from '../redux/hooks';

export const useDateFilters = () => {
  const startDate = new Date(useAppSelector((state) => state.filters.start));
  const endDate = new Date(useAppSelector((state) => state.filters.end));
  return [startDate, endDate];
};
